// Jednotné sestavení zobrazovaného jména uživatele napříč celou aplikací.
// Priorita: přezdívka → jméno + příjmení → nouzový fallback.
// Skutečné jméno (fullName) se zobrazuje jen v detailech, jen když je vyplněné.
// Díky tomu se nikde nezobrazí "- -" ani prázdno (viz App Store / konzistence UI).

function clean(value) {
    if (!value || typeof value !== "string") return "";
    const trimmed = value.trim();
    // "-" je historický placeholder za prázdné jméno/příjmení
    return trimmed && trimmed !== "-" ? trimmed : "";
}

export function firstName(user) {
    return user ? clean(user.firstName) : "";
}

export function lastName(user) {
    return user ? clean(user.lastName) : "";
}

// First name + last name, or "" when not filled in. Search lists send it prebuilt as "fullName".
export function fullName(user) {
    if (!user) return "";

    return [clean(user.firstName), clean(user.lastName)]
        .filter(Boolean)
        .join(" ") || clean(user.fullName);
}

export function displayName(user) {
    if (!user) return "Uživatel";

    const realName = fullName(user);

    // server někdy posílá pole jako "nickname" (malé n), proto kontrolujeme obě
    const nick = clean(user.nickName) || clean(user.nickname);

    // Některé výpisy (hledání, chat) posílají z serveru už sestavené jméno v poli "name"
    // – v takovém objektu žádná surová pole (firstName/nickName) nejsou.
    const precomputed = clean(user.name);

    return nick || precomputed || realName || "Uživatel";
}

export default displayName;
